import React, { useEffect } from "react";
import { Box, Button } from "@mui/material";
import { AddCircleOutline } from "@mui/icons-material";
import {
  ErrorMessage,
  FormikErrors,
  FormikValues,
  useFormikContext,
} from "formik";

import FileUploadButton from "../../../../../common/Form/FileUpload/FileUploadButton";
import ErrorValidationOnGrid from "../../../../../common/Form/Error/ErrorValidationOnGrid";
import { romanize } from "../../../../../../utils/helper";
import { DOCUMENTS, DROPDOWN_SELECTED_VALUE, DROPDOWN_VALUES, IS_DELETABLE, IS_EDITABLE, IS_INPUT_OPENED, LABEL, REMARK, REQUIRED, _URL } from "../../../../../../constants/forms";
import DocumentListDropdown from "../../../../../common/Form/Dropdown/DocumentListDropdown";
import { DocumentSubmissionDropdown } from "../../../../../../types/forms/DoumentSubmission";
interface IDocumentLabel {
  changeLabelName: (e: React.ChangeEvent<HTMLInputElement>, i: number) => void;
  item: any;
  index: number;
  changeLabelToInput: (i: number) => void;
}

interface FormErrors {
  [key: string]: string | string[] | FormikErrors<any> | FormikErrors<any>[];
}

const SubmittedDocumentsSection = (props: {
  fieldName: string;
  labelText?: string;
  isShowRemark?: boolean;
}) => {
  const { fieldName, labelText, isShowRemark = true} = props;
  const {
    values,
    initialValues,
    errors,
    touched,
    setFieldTouched,
    setFieldValue,
  } = useFormikContext<FormikValues>();

  const deleteInputGrid = (i: number) => {
    const prev = [...values[fieldName]];
    if (prev.length > 0) {
      const filteredData = prev.filter((field, index) => i !== index);
      setFieldValue(fieldName, filteredData);
    }
  };

  const changeLabelToInput = (i: number) => {
    const data = [...values[fieldName]];
    if (data[i][IS_EDITABLE] === false) {
      return;
    }

    data[i][IS_INPUT_OPENED] = !data[i]["isInputOpened"];
    setFieldValue(fieldName, data);
  };

  const addInputFromGrid = () => {
    const prevData = [...values[fieldName]];
    setFieldValue(fieldName, [
      ...prevData,
      {
        [LABEL]: "",
        [REQUIRED]: initialValues[fieldName].length === 0 ? true : false,
        [_URL]: "",
        [IS_DELETABLE]: true,
        [IS_INPUT_OPENED]: true,
        [DROPDOWN_VALUES]: [],
        [DROPDOWN_SELECTED_VALUE]: '',
      },
    ]);
  };

  const changeLabelName = (
    e: React.ChangeEvent<HTMLInputElement>,
    i: number
  ) => {
    const prevData = [...values[fieldName]];
    prevData[i][LABEL] = e.target.value;
    setFieldValue(fieldName, prevData);
  };

  const onRemarkChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    i: number
  ) => {
    const prevData = [...values[fieldName]];
    prevData[i][REMARK] = e.target.value;
    setFieldValue(fieldName, prevData);
  };

  const gerFieldErrors = (i: number) => {
    let result: any = { ...errors };
    if (typeof result[fieldName]?.[i] === "object" && touched[fieldName]) {
      return Object.values(result[fieldName][i]);
    }
    return [];
  };

  useEffect(() => {
    setFieldTouched(DOCUMENTS, false);
  }, []);

  return (
    <Box className=" mg-b-0  mg-t-20 ">
      <label className="form-label font-weight-medium">
        {labelText || "2.1 Documents Submitted - MIRB"}
      </label>

      {values[fieldName]?.length > 0 &&
        values[fieldName]?.map((item: DocumentSubmissionDropdown, i: number) => (
          <Box key={i}>
            <Box className="d-flex align-items-center justify-content-start gap-sm mg-b-10 ">
              <label className="form-label">
                {" "}
                {romanize(i + 1)}
                {") "}
              </label>

              <Box
                className={`d-flex justify-content-between align-items-center gap-sm width-85`}
              >
                <DocumentLabel
                  item={item}
                  changeLabelName={changeLabelName}
                  index={i}
                  changeLabelToInput={changeLabelToInput}
                />

                <DocumentListDropdown item={item} fieldName={fieldName} index={i}/>
                
                <FileUploadButton
                  protocolNumber={values.protocolNumber}
                  showError={false}
                  name={fieldName}
                  docName={item.label}
                  gridName={_URL}
                  index={i}
                  label="Upload"
                  className="mg-t-0"
                />
                
                {isShowRemark && <input
                  type="text"
                  className="form-control"
                  placeholder="Remark"
                  aria-label="Remark"
                  value={item[REMARK]}
                  onBlur={() => changeLabelToInput(i)}
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                    onRemarkChange(e, i)
                  }
                />}
              </Box>

              {item?.[IS_DELETABLE] && (
                <button
                  onClick={() => deleteInputGrid(i)}
                  type={"button"}
                  className={`btn btn-link text-danger`}
                >
                  <i className={`icon-trash`}></i>
                </button>
              )}
            </Box>
            {gerFieldErrors(i).map((msg, i) => (
              <p
                key={`doc-error-${msg}`}
                className="text-danger font-size-sm mb-5"
                style={{ marginBottom: "15px" }}
              >
                {`${msg}`}
              </p>
            ))}
          </Box>
        ))}
      {typeof errors[fieldName] === "string" && (
        <ErrorMessage
          name={fieldName}
          render={(msg) => {
            return (
              <div>
                <span className="text-danger font-size-sm">{msg}</span>
              </div>
            );
          }}
        />
      )}
      <br />
      <Button
        variant={"text"}
        color={"error"}
        onClick={addInputFromGrid}
        type="button"
      >
        <AddCircleOutline className="mg-r-10" />
        Add Other if any
      </Button>
    </Box>
  );
};

const DocumentLabel = (props: IDocumentLabel) => {
  const { item, changeLabelName, index: i, changeLabelToInput } = props;
  return (
    <>
      {!item?.[IS_INPUT_OPENED] ? (
        <label
          className="form-label mg-b-0 font-size-14 width-60"
          onClick={() => changeLabelToInput(i)}
        >
          {item[LABEL]}
          {item?.[REQUIRED] && <span className="error"> * </span>} :{" "}
        </label>
      ) : (
        <>
          <input
            type="text"
            className="form-control width-50"
            placeholder="Type document name"
            value={item[LABEL]}
            onBlur={() => changeLabelToInput(i)}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
              changeLabelName(e, i)
            }
          />
        </>
      )}
    </>
  );
};

export default SubmittedDocumentsSection;
